import React from 'react';

const PickerPointerCircle = () => {
    return (
        <div
            className={`w-28 h-28 rounded-circle transform -translate-x-2/4 -translate-y-2/4`}
            style={{
                background: 'linear-gradient(277.76deg, #FFFFFF 8.91%, rgba(255, 255, 255, 0.6) 87.9%)',
                boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.25)',
                border: '2px solid #FFFFFF',
            }}
        />
    );
};

export default PickerPointerCircle;
